module.exports = __webpack_public_path__ + "static/media/rociodeluna.639ed3ea.webp";